/**
 * Created by Mikhail Menshenin on 18.07.2024
 */

SyncAdapters.medalCollection = {
    getInfo: () => aisensia.medalCollection && aisensia.medalCollection.getInfo(),
    updateInfo: (data) => {
        if (aisensia.medalCollection) {
            aisensia.medalCollection.updateInfo(data);
            aisensia.medalCollection.save();
        }
    }
};
